import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'typeface-roboto'; // eslint-disable-line
import AppContainer from './ui/app/AppContainer';
import * as serviceWorker from './serviceWorker';

import apiManager from './app-init/apiManager';
import store from './state/store';
import './index.css';

apiManager(store);

ReactDOM.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
